import React from "react";

import { useDictionary } from "hooks";
import { CAYUSE_TYPES } from "globals/constants";

import Integration from "./Integration";


function HazardSafetySearch (props) {
	const dictionary = useDictionary('hazardSafetySearch');

	return <Integration title={dictionary.headline ?? 'Link to Hazard Safety'} { ...props }/>;
}

HazardSafetySearch.showInPalette = () => true;

HazardSafetySearch.paletteInformation = () => ({
	id: "cayuseHazardSafety",
	name: "Hazard Safety Protocol Search",
	type: "cayuseHazardSafety",
	group: "sponsoredProject"
});

HazardSafetySearch.newElement = () => ({
	designInfo: {
		stencilSuperIds: [
			"Component"
		],
		stencilId: "cayuse-hazard-safety",
		customStencilId: "null"
	},
	type: CAYUSE_TYPES.HAZARD_SAFETY,
	cayuseShortLabel: "Hazard Safety Protocol Search"
});

HazardSafetySearch.initialValue = "{{hazardSafety}}";


export default HazardSafetySearch;
